module.exports = __webpack_public_path__ + "img/forget-pwd-bg.88a345c5.png";